var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07785 10.0648H4.65285V16.0648C4.65285 17.4648 5.41119 17.7481 6.33619 16.6981L12.6445 9.53146C13.4195 8.65646 13.0945 7.93146 11.9195 7.93146H9.34452V1.93146C9.34452 0.531458 8.58619 0.248124 7.66119 1.29812L1.35285 8.46479C0.586185 9.34812 0.911185 10.0648 2.07785 10.0648Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.1972ab11538271dc06ce30c377b53b19.svg";
export { ForwardRef as ReactComponent };